export default function ComplianceDocumentsList() {
  return (
    <div className="w-full p-6">
      <h1 className="text-2xl font-semibold mb-2">Compliance Documents</h1>
      <p className="text-muted-foreground">
        Document list (AGB, TOMs, Privacy Policy, SLA, DPA + custom) ships in D2
        (Documents — admin UI). Backend CRUD + versioning ships in D1.
      </p>
    </div>
  )
}
